"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInternalAddress = exports.SENDMULTISIG_SIG_HASH = void 0;
const ethers_1 = require("ethers");
const multiSig_1 = __importDefault(require("./abi/multiSig"));
const utils_1 = require("./utils");
const abiInterface = new ethers_1.ethers.utils.Interface(multiSig_1.default);
exports.SENDMULTISIG_SIG_HASH = abiInterface.getSighash('sendMultiSig');
// detect address associated with sendMultiSig internal transaction
const getInternalAddress = (inputData) => {
    if (utils_1.getSigHash(inputData) !== exports.SENDMULTISIG_SIG_HASH)
        return;
    const result = abiInterface.decodeFunctionData(exports.SENDMULTISIG_SIG_HASH, inputData);
    return result.toAddress;
};
exports.getInternalAddress = getInternalAddress;
